const { useCallback, useEffect } = require('react');

const useLockScroll = (lockOnMount = false) => {
  const handleLockScroll = useCallback(lock => {
    document.body.style.overflowY = lock ? 'hidden' : 'auto';
  }, []);

  useEffect(() => {
    if (lockOnMount) {
      handleLockScroll(true);
    }
  }, [lockOnMount]);

  useEffect(() => {
    return () => {
      handleLockScroll(false);
    };
  }, []);

  return {
    handleLockScroll,
  };
};

export default useLockScroll;
